import InputTypesEnum from '../../../Enums/InputTypesEnum';
import importListHelper from '../../../Helpers/importListHelper';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import TpJobSearchParams from './TpJobSearchParams';

export default class ProjectTpJobSearchParams extends TpJobSearchParams {
  initialize() {
    this.TpJobId = '';
    this.ThirdPartyJobId = '';
    this.ThirdPartySources = [];
    this.ThirdPartyLocationName = '';
    this.ThirdPartyJobStatus = '';
    this.SelectedFieldworkOfficeIds = '';
    this.UseCompletedDateRange = false;
    this.DateCompletedFrom = dateTimeHelper.indefiniteDateValue();
    this.DateCompletedTo = dateTimeHelper.indefiniteDateValue();
    this.ProjectId = '';
    this.ClientId = '';
    this.SearchType = '';
    this.SelectedOwningOfficeIds = '';
    this.IsCollabStatusDifferent = '';
    this.AdHocGroup = '';
    this.TpSurveyId = '';
    this.CampaignName = '';
    this.SelectedCountryCodes = [];
  }

  // Override inherited tabs from TpJobSearchParams — fields here have no tab assignments,
  // so showing tabs makes them appear stuck on 'Linking' (all fields render on every tab).
  static tabsOnTheSearchPanel = null;

  static fieldsInSearchBox = [
    {
      fieldName: 'TpJobId',
      label: 'IDs',
      className: 'col-3',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
    },
    {
      fieldName: 'ThirdPartyJobId',
      label: 'Third-Party Job IDs',
      className: 'col-3',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
    },
    {
      fieldName: 'ThirdPartySources',
      label: 'Third Party Sources',
      className: 'col-3',
      type: InputTypesEnum.ThirdPartySourceTpJobMultiChoice,
    },
    {
      fieldName: 'ThirdPartyLocationName',
      label: 'Location Name',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'ThirdPartyJobStatus',
      label: 'Status',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'SelectedFieldworkOfficeIds',
      label: 'Fieldwork Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'UseCompletedDateRange',
      label: 'Use Completed Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'DateCompletedFrom',
      label: 'Date Completed From',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCompletedDateRange,
    },
    {
      fieldName: 'DateCompletedTo',
      label: 'Date Completed To',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCompletedDateRange,
    },
    {
      fieldName: 'SelectedOwningOfficeIds',
      label: 'Owning Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'IsCollabStatusDifferent',
      label: 'Collab Status Different?',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    {
      fieldName: 'AdHocGroup',
      label: 'Ad-Hoc Invoice Group',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      // Lists the surveys of the tab's client, so it is shown only where the tab has one.
      fieldName: 'TpSurveyId',
      label: 'Survey',
      className: 'col-3',
      type: InputTypesEnum.TpSurveySelect,
      idFilter: (searchItem) => searchItem.ClientId,
      showCondition: (searchItem) => !!searchItem.ClientId,
    },
    {
      fieldName: 'CampaignName',
      label: 'Campaign',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'SelectedCountryCodes',
      label: 'Countries',
      className: 'col-3',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
  ];
}
